export default __webpack_public_path__ + "static/media/backtopbtn.97d5911b.svg";